import React from 'react';

import styled from 'styled-components';

import { Animation } from 'components/lottie-animations/favorite-loading';

const ANIM_SIZE = 37;

const IconWrapper = styled.div`
  position: relative;
  height: 20px;
  width: 22px;
`;

const LottieWrapper = styled.div`
  position: absolute;
  top: -9px;
  left: -7px;
`;

const LoadingAnimation = () => (
  <IconWrapper>
    <LottieWrapper>
      <Animation style={{ width: ANIM_SIZE, height: ANIM_SIZE }} />
    </LottieWrapper>
  </IconWrapper>
);

export default LoadingAnimation;
